import { useMutation } from '@tanstack/react-query';

import { exportEmergencyFillUpReport } from '../../../../common/api/clients/export.api';

export const useEmergencyFillUpReportDownload = () => {
    return useMutation({ mutationFn: exportEmergencyFillUpReport });
};
